import { UserAccessList } from "../../../shared/screen-components/UserAccessListComponent/UserAccessList";
import { StyledProjectSection } from "../../DeliverableView/pages/DeliverableDetails/DeliverableDetails.styles";

const UserAccess = () => {
  return (
    <StyledProjectSection>
      <UserAccessList />
    </StyledProjectSection>
  );
};

export default UserAccess;
